export const HAPTIC = {
  LIGHT_ATTACK: { pattern: [30], intensity: [0.5], total: 30 },
  HEAVY_ATTACK: { pattern: [40, 20, 40], intensity: [0.8], total: 100 },
  CRITICAL_HIT: { pattern: [20, 10, 20, 10, 60], intensity: [1.0], total: 120 },
  DODGE: { pattern: [15, 5, 30], intensity: [0.4], total: 50 },
  BLOCK: { pattern: [60], intensity: [0.7], total: 60 },
  GUARD_BREAK: { pattern: [50, 30, 70], intensity: [0.9], total: 150 },
  TAKE_DAMAGE: { pattern: [80], intensity: [0.6], total: 80 },
  LOW_HEALTH: { pattern: [30, 500, 30, 500, 30], intensity: [0.3], total: 1090 },
  MOMENTUM_25: { pattern: [40], intensity: [0.4], total: 40 },
  MOMENTUM_50: { pattern: [30, 10, 20], intensity: [0.6], total: 60 },
  MOMENTUM_75: { pattern: [20, 10, 20, 10, 20], intensity: [0.8], total: 80 },
  MOMENTUM_100: { pattern: Array(10).fill(50), intensity: [1.0], total: 500 },
  HARVEST_DRAW: { pattern: [30, 20, 30, 20, 30, 20, 40], intensity: [0.6], total: 200 },
  DISSOLVE: { pattern: [20, 10, 20, 10, 20, 10, 20], intensity: [0.5], total: 110 },
  TUNNEL: { pattern: Array(40).fill(50), intensity: [0.2], total: 2000 },
  EMERGE: { pattern: [30, 20, 100], intensity: [0.8], total: 150 },
  BOSS_PHASE: { pattern: [100, 50, 100], intensity: [0.9], total: 250 },
  BOSS_ENRAGE: { pattern: Array(5).fill(80), intensity: [1.0], total: 400 },
  BOSS_DEATH: { pattern: [200], intensity: [0.4], total: 200 },
  DEATH: { pattern: [100, 50, 100, 50, 100], intensity: [0.3], total: 400 },
  FORGE_SUCCESS: { pattern: [20, 300], intensity: [0.7], total: 320 },
  COVEN_ALERT: { pattern: [10, 5, 10], intensity: [0.5], total: 25 },
  MENU_OPEN: { pattern: [15], intensity: [0.3], total: 15 },
  MENU_SELECT: { pattern: [10], intensity: [0.2], total: 10 }
} as const;

export function haptic(key: keyof typeof HAPTIC): void {
  if (!navigator.vibrate) return;
  navigator.vibrate([...HAPTIC[key].pattern]);
}
